export default __webpack_public_path__ + "static/media/Logo.6e4b2e95.svg";